import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=b0648030&"
import script from "./DashboardPage.js?vue&type=script&lang=js&"
export * from "./DashboardPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports